/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Channelconfirmsend2Inputs */

const en_channelconfirmsend2 = /** @type {(inputs: Channelconfirmsend2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Send now`)
};

const de_channelconfirmsend2 = /** @type {(inputs: Channelconfirmsend2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Jetzt senden`)
};

/**
* | output |
* | --- |
* | "Send now" |
*
* @param {Channelconfirmsend2Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const channelconfirmsend2 = /** @type {((inputs?: Channelconfirmsend2Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Channelconfirmsend2Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_channelconfirmsend2(inputs)
	return de_channelconfirmsend2(inputs)
});
export { channelconfirmsend2 as "channelConfirmSend" }